import { PhoneNumberCountryCode, validateURL, validateURLMessage, yup } from '@reapitform/utils'

export const schemaAddLink = yup.object({
  id: yup.string().optional(),
  formType: yup.string().required('Form type is required'),
  title: yup.string().required('Title is required'),
  url: yup
    .string()
    .test(
      'isValidUrl',
      'Invalid URL',
      (value) => validateURL(value ?? '').errorMessage !== validateURLMessage['general-invalid-url'],
    )
    .test(
      'isValidUrl',
      'Invalid URL - Missing URL Protocols (HTTP/HTTPS)',
      (value) => validateURL(value ?? '').errorMessage !== validateURLMessage['missing-protocols'],
    )
    .required('URL is required'),
})

export const schemaDefaultDocuments = yup.object({
  formType: yup.string().required('Form type is required'),
  document: yup
    .object({
      fileId: yup.string().required('Document still uploading'),
      fileName: yup.string().required('Document still uploading'),
      fileSize: yup.number().required('Document still uploading'),
      status: yup.string(),
    })
    .default(undefined)
    .required('Please select the document to upload')
    .test({
      test: (value) => !value || !(!value?.fileId && !value?.status),
      message: 'Please select the document to upload',
      name: 'document-empty',
    })
    .test({
      test: (value) => !value || value?.status !== 'ERROR',
      message: 'Failed to proccessing the document',
      name: 'upload-error',
    }),
})

export const schemaDefaultEmergencyContacts = (countryCode?: PhoneNumberCountryCode) =>
  yup.object({
    id: yup.string().optional(),
    businessName: yup.string().required('Enter a business name'),
    contactName: yup.string().optional().default(''),
    phone: yup.string().phoneNumber(countryCode).required('Enter a phone number'),
    mobile: yup.string().mobileNumber(countryCode).optional().default(''),
    useAsDefault: yup.boolean().optional().default(false),
    contactType: yup.string().required('Select the repairer type'),
  })

export const schemaDefaultSpecialTerms = yup.object({
  id: yup.string().optional(),
  title: yup.string().required('A template title is required'),
  useAsDefault: yup.boolean().optional().default(false),
  clauses: yup
    .array(yup.object({ value: yup.string() }))
    .test('min1ValidValue', 'At least one clause must be added to the template', (value) => {
      const isHaveValue = Array.isArray(value) && value.length > 0
      if (!isHaveValue) return false

      const isHaveOneValidClause = value.find((clause) => Boolean(clause.value))

      return Boolean(isHaveOneValidClause)
    }),
})
